module.exports = __webpack_public_path__ + "img/money.45a7ae98.png";